module.exports = __webpack_public_path__ + "static/media/ring.69b29a4c.mp3";